import type { settings as enSettings } from "../en/settings";

export const settings: typeof enSettings = {
  hub: {
    heading: "Impostazioni",
    plan: {
      heading: "Piano",
      currentTierPrefix: "Piano attuale:",
      trialEnds: "La prova termina il {{date}}",
      manageBillingButton: "Gestisci fatturazione",
    },
    quoteNumbering: {
      heading: "Numerazione preventivi",
      prefixLabel: "Prefisso:",
    },
    priceLists: {
      heading: "Listini prezzi B2B",
      description:
        "Cura prezzi fissi per variante e assegnali alle aziende. I nuovi preventivi si precompilano dal listino dell'azienda.",
      manageButton: "Gestisci listini prezzi",
    },
    verification: {
      heading: "Strumento di verifica",
      runButton: "Esegui la verifica delle regole di prezzo",
    },
  },
  billing: {
    pageHeading: "Fatturazione",
    gatedBanner: {
      prefix: "Sblocca {{feature}} con il piano",
      suffix: "Scegli {{plan}} qui sotto per attivarlo.",
      defaultFeature: "questa funzione",
    },
    gatedFeature: {
      PRO: "l'analisi dei PDF degli ordini d'acquisto e i suggerimenti di prezzo IA",
      GROWTH: "il motore di controfferte IA e la verifica delle regole di prezzo",
    },
    currentPlan: {
      heading: "Piano attuale",
      youreOnPrefix: "Sei sul piano",
      trialEnds: "La prova termina il {{date}}",
    },
    freePlanUsage: {
      heading: "Utilizzo del piano Free",
      usedOfCap: "{{used}} di {{cap}}",
      usedInLast30Days: "preventivi gratuiti utilizzati negli ultimi 30 giorni",
      remainingSuffix: "— {{remaining}} rimanenti",
      limitReachedBanner:
        "Hai raggiunto il limite gratuito. Passa a Starter per preventivi illimitati — i tuoi preventivi esistenti restano completamente modificabili.",
    },
    choosePlan: {
      heading: "Scegli un piano",
      description:
        "I piani vengono approvati sulla pagina sicura dei piani di Shopify — scegline uno lì e tornerai direttamente qui con tutto sbloccato.",
      freeForever: "$0 per sempre",
      perMonth: "/mese",
      currentPlanCta: "Piano attuale",
      switchToFreeCta: "Passa a Free su Shopify",
      chooseCta: "Scegli {{name}} su Shopify",
    },
    tierDescriptions: {
      FREE: {
        bullet1: "L'intero flusso preventivo → accettazione → ordine bozza",
        bullet2: "Elenco aziende, link pubblici ai preventivi, prezzi negoziati",
        bullet3: "PDF dei preventivi personalizzati con il tuo brand",
        bullet4: "Fino a 5 preventivi in una finestra di 30 giorni",
      },
      STARTER: {
        bullet1: "Tutto ciò che include Free, più:",
        bullet2: "Preventivi illimitati — nessun limite mensile",
        bullet3: "Importazione CSV in blocco + esportazione filtrata",
      },
      PRO: {
        bullet1: "Tutto ciò che include Starter",
        bullet2: "Analisi PDF ordine d'acquisto → ordine bozza con corrispondenza righe basata su punteggio di affidabilità",
        bullet3: "Suggerimenti di prezzo IA — ogni riga di preventivo prezzata in base allo storico ordini dell'acquirente",
      },
      GROWTH: {
        bullet1: "Tutto ciò che include Pro",
        bullet2: "Motore di controfferte IA basato sullo storico ordini",
        bullet3: "Strumento di verifica per le regole di prezzo",
      },
    },
  },
  verification: {
    pageHeading: "Strumento di verifica",
    gatedBanner: {
      prefix: "Lo strumento di verifica è incluso nel piano",
      suffix: ".",
      upgradeLink: "Aggiorna il piano",
    },
    whatThisDoes: {
      heading: "Come funziona",
      description:
        "Riesegue un insieme di regole di prezzo sugli ordini storici di un'azienda specifica. Ti dice quale frazione degli ordini passati avrebbe prodotto totali identici con queste regole — utile prima di attivare un nuovo insieme di regole sui preventivi live.",
    },
    dispatchedBanner: {
      prefix: "Verifica avviata (id esecuzione",
      suffix: "). I risultati compaiono qui sotto tra circa 30 secondi.",
    },
    runVerification: {
      heading: "Esegui verifica",
      pricingRuleVersionLabel: "Versione delle regole di prezzo",
      versionOption: "v{{version}} — {{date}}",
      companyIdLabel: "GID azienda (opzionale, esecuzione mirata)",
      submitButton: "Esegui verifica",
    },
    recentRuns: {
      heading: "Esecuzioni recenti",
      empty: "Nessuna esecuzione ancora.",
      matchesText: "{{matches}}/{{inputCount}} corrispondenze",
    },
    errors: {
      versionRequired: "Versione delle regole di prezzo obbligatoria.",
      versionNotFound: "Versione delle regole di prezzo non trovata per questo negozio.",
      dispatchFailed: "Impossibile raggiungere il servizio di verifica. Riprova, oppure contatta l'assistenza se il problema persiste.",
    },
  },
};
